import { useEffect, useRef } from "react";

const useScroll = (doc, callback, nameOrOptions = {}) => {
    const options = typeof nameOrOptions === 'string'
        ? { name: nameOrOptions }
        : nameOrOptions;
    const {
        debounce: debounceMs = 100,
        capture = true,
    } = options;

    const callbackRef = useRef(callback);
    callbackRef.current = callback;

    useEffect(() => {
        if (!doc) return;

        let timeoutId = null;
        const handler = (e) => {
            if (debounceMs <= 0) {
                callbackRef.current(e);
                return;
            }
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => callbackRef.current(e), debounceMs);
        };

        doc.removeEventListener('scroll', handler, capture);
        doc.addEventListener('scroll', handler, capture);

        return () => {
            clearTimeout(timeoutId);
            doc.removeEventListener('scroll', handler, capture);
        };
    }, [doc, debounceMs, capture]);
};

export default useScroll;
